import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import { useLocation } from 'react-router';

import { useBreadcrumbOverride } from './BreadcrumbContext';
import BreadcrumbCurrent from './BreadcrumbCurrent';
import BreadcrumbLink from './BreadcrumbLink';
import { buildBreadcrumbs } from './utils';

export { useBreadcrumb } from './BreadcrumbContext';

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const { override } = useBreadcrumbOverride();
  const breadcrumbs = buildBreadcrumbs(pathname, override);

  return (
    <Box
      component="nav"
      aria-label="Breadcrumb"
      sx={(theme) => ({
        px: { xs: 2, md: 3 },
        py: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.mode === 'dark' ? 'background.default' : theme.palette.grey[100],
      })}
    >
      <MUIBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          display: 'flex',
          alignItems: 'center',
          '& .MuiBreadcrumbs-ol': {
            alignItems: 'center',
          },
          '& .MuiBreadcrumbs-li': {
            display: 'inline-flex',
            alignItems: 'center',
          },
          '& .MuiBreadcrumbs-separator': {
            display: 'inline-flex',
            alignItems: 'center',
            mx: 0.5,
          },
        }}
      >
        {breadcrumbs.map((crumb) =>
          crumb.isCurrent ? (
            <BreadcrumbCurrent key={crumb.key} label={crumb.label} icon={crumb.icon} />
          ) : (
            <BreadcrumbLink key={crumb.key} label={crumb.label} path={crumb.path} icon={crumb.icon} />
          ),
        )}
      </MUIBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
